<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-2 -2 28 28"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                          d="M16 22.621l-3.521-6.795c-.007.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.082-1.026-3.492-6.817-2.106 1.039c-1.639.855-2.313 2.666-2.289 4.916.075 6.948 6.809 18.071 12.309 18.045.541-.003 1.07-.113 1.58-.346.121-.055 2.102-1.029 2.11-1.033zm-2.5-13.621c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm9 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-4.5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"/>
                </svg>
            </div>
        </template>
        <div>
            <package-contact-search
                class="flex-1"
                #default="{ open, query, setQuery }"
                @selected:contact="contactSelected"
                :top="true"
                :contacts="contacts"
                mode="phone"
                :show-phone="true"
            >
                <ui-input label="Send to" v-model="form.to"
                          placeholder="Email address/phone number..."
                          class="xl:col-span-12"
                          @input="setQuery(form.to?form.to:name); error=false"
                          @focus="setQuery(form.to?form.to:name); error=false; open()"
                ></ui-input>
                <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
            </package-contact-search>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="form.busy" @click="form.submit()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";

export default {
    components: {UiButtonNew, PackageContactSearch, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Send signature request'
        },
        button: {
            type: String,
            default: 'Send signature request'
        },
        name: '',
        contacts: {}
    },
    data() {
        return {
            form: new Form({}, async (form) => {
                await this.handle(form, this)
            }),
            error: false,
        }
    },
    methods: {
        contactSelected(e) {
            this.form.to = e.phone;
        },
    }
}
</script>
